var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-section',{attrs:{"title":_vm.sectionTitle}},[_c('kst-input',{attrs:{"field":"SelfWarehouseID","data":_vm.userData,"catalog":_vm.Catalog,"options":_vm.warehouseOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }